var ICON_CONTAINER_CLASS = 'ads-input-icon-container';

export { ICON_CONTAINER_CLASS };
//# sourceMappingURL=constants.js.map
